module.exports = __webpack_public_path__ + "img/watchlistremove.3a84f0fd.svg";